import { createRef } from "preact";
import { route } from "preact-router";
import { useContext, useState } from "preact/hooks";
import authWrapper from '../../Utilities/authGarage/authGarage';
import { CoreState } from "../../Utilities/contextLibrary";
import LogRocket from 'logrocket';
// import analytics from '../../Utilities/analytics';
import api from "../../Utilities/API/api";


const PromptLogin = () => (
    <>
        Confirmation failed, please try again: <a href="?stage=login">Login</a>
    </>
)
const InvalidCode = () => (
    <>
        Invalid Code: Please verify the accuracy of your code, and try again.
    </>
)

export default ({ context, listenerName }) => {
    const {authState, setAuthState} = useContext(context)
    const { coreDispatch } = useContext(CoreState);

    const codeRef = createRef(null)

    const [prompt, setPrompt] = useState({
        title: 'Complete MFA', 
        content: 'Enter the code generated by your authenticator app',
        isError: false
    })
    const previousPage = () => {

    }
    const handleSubmit = async e => {
        e.preventDefault();

        console.log('submitting')
        const code = codeRef.current.value
        codeRef.current.value = null

        // NEED TO HANDLE STATE
        const { status, headers, response } = await authWrapper.challengeResponder(
            'SOFTWARE_TOKEN_MFA',
            {
                'USERNAME': authState.user.email,
                'SOFTWARE_TOKEN_MFA_CODE': code
            },
            authState.user.session
        )

        if (status != 200) {
            setPrompt({...prompt,
                content: (() => {
                    switch (headers['x-amzn-errortype']) {
                        
                        case 'NotAuthorizedException:': return <PromptLogin />
                        case 'CodeMismatchException:': return <InvalidCode />
                        default: return headers['x-amzn-errormessage']
                    }
                })(),
                isError: true
            })
            return
        } else {
            const tokens = authWrapper.parseAuthenticationResult(response.AuthenticationResult);
            const identityToken = authWrapper.userinfo(tokens.id_token);

            console.log('USERINFO: ', identityToken)

            coreDispatch({ type: 'tokens', payload: tokens});
            coreDispatch({ type: 'userinfo', payload: identityToken});

            console.log('dispatch complete')

            // COOKIE-REVIEW: LogRocket.identify() and analytics.identify() after successful MFA.
            // Links authenticated user identity to tracking cookies/sessions for personalized analytics.
            // To disable: Remove or gate behind consent for authenticated user tracking.
            LogRocket.identify(identityToken.email, {
				name: identityToken.given_name + ' ' + identityToken.family_name,
				uuid: identityToken.sub
			  });
			// Initialize logging to GA for user session tracking
			// analytics.identify(identityToken.email, {
			// 	name: identityToken.given_name + ' ' + identityToken.family_name,
			// 	uuid: identityToken.sub
			// });

            console.log('LR and ANALYTICS complete')

            try {
                const customer = await api.get(tokens.id_token,'customer/', 'apiv5');
                console.log('CUSTOMER: ', customer.response);
                coreDispatch({ type: 'customer', payload: customer.response });
                coreDispatch({ type: 'role', payload: customer.response.CLIENTSTATUS });
                coreDispatch({ type: 'isAuth', payload: true });
                setAuthState({...authState, stage: 'route-user'});
            } catch (e) {
                console.log('Error: ', e);
                if ('message' in customer.response) {
                    // console.log('error: customer registration failed', res);
                    window.alert('looks like we hit a snag, if this is your first time seeing this message please refresh the page and try again, otherwise please contact support for further assistance.');
                    window.location.reload();
                }
            }
        }
    }

    return (
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
            <div class="content-container">
                <h1>{prompt.title}</h1>
                <p className={prompt.isError ? 'error-message' : ''}>{prompt.content}</p>
                <br />
                <div className="form-element">
                    <label htmlFor="code">Verification Code</label>
                    <input 
                        autocomplete="one-time-code"
                        name="code"
                        id="code" 
                        ref={codeRef} 
                        placeholder="123456"
                        data-testid="code"
                        maxLength="6"
                    />
                </div>
                <div className="button-bar">
                    <button name="validate" className="primary">Validate</button>
                </div>
            </div>
        </form>
    )
}